import { useAdyenCardAddEnabled } from 'hooks/useAdyenCardAddEnabled';
import useWalletCapability from 'hooks/useWalletCapability';
import type { AdyenWalletType } from 'types/generatedSchemaTypes';
import { shouldShowWalletAddRow } from 'utils/paymentUtils';

export const WALLET_TYPES: ReadonlyArray<AdyenWalletType> = [
  'APPLE_PAY',
  'GOOGLE_PAY',
];

// Wallet types offered for adding (card-add flag x platform capability). An
// Active/Verifying wallet of a listed type is still shown, as a non-selectable
// "Added" row, rather than hidden.
const useVisibleWalletTypes = (): AdyenWalletType[] => {
  const cardAddEnabled = useAdyenCardAddEnabled();
  const { applePay, googlePay } = useWalletCapability();

  const capableByWallet: Record<AdyenWalletType, boolean> = {
    APPLE_PAY: applePay,
    GOOGLE_PAY: googlePay,
  };
  return WALLET_TYPES.filter((walletType) =>
    shouldShowWalletAddRow({
      cardAddEnabled,
      capable: capableByWallet[walletType],
    })
  );
};

export default useVisibleWalletTypes;
